import { db } from "@/firebase/init.js";
import {
  collection,
  orderBy,
  query,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  // arrayUnion,
  where,
} from "firebase/firestore";

const groupsModule = {
  namespaced: true,
  state: {
    groupsList: [],
    classesOfGroups: [],
    updateGroup: {},
    isLoading: true,
    isGroupFirstLoad: true,
  },
  getters: {
    getGroups: (state) => state.groupsList,
    getUpdateGroup: (state) => state.updateGroup,
    getClassesOfGroups: (state) => state.classesOfGroups,
    isLoading: (state) => state.isLoading,
    isGroupFirstLoad: (state) => state.isGroupFirstLoad,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setGroupFirstLoad: (state, payload) => {
      state.isGroupFirstLoad = payload;
    },

    // Get All Groups
    setGroups: (state, payload) => {
      state.groupsList = payload;
    },

    setClassesOfGroup: (state, payload) => {
      state.classesOfGroups = payload;
    },

    // Add Group
    addGroup: (state, payload) => {
      if (state.groupsList.length > 0) state.groupsList.unshift(payload);
      else state.groupsList = [payload];
    },

    // Update Group
    updateSelectedGroup: (state, payload) => {
      const findIndex = state.groupsList.findIndex(
        (group) => group.group_id == payload.group_id
      );
      state.groupsList[findIndex] = payload;
    },

    // get Group by id
    getSelectedGroupById: (state, payload) => {
      state.updateGroup = payload
    },

    // Delete Group
    deleteGroup: (state, payload) => {
      let filtered = state.groupsList.filter(function (value) {
        return value.group_id != payload;
      });
      state.groupsList = filtered;
    },

    // Add Class
    setAddClassToGroup: (state) => {
      state.classesOfGroups = [];
    },
  },
  actions: {
    // Fetch All Groups
    async fetchGroups({ commit }) {
      commit("setLoading", true);
      commit("setGroupFirstLoad", true);
      const groupsList = await getDocs(
        query(collection(db, "Groups"), orderBy("created_date", "desc"))
      );
      let groupArray = [];
      if (!groupsList.empty) {
        groupsList.forEach((doc) => {
          groupArray.push({ ...doc.data(), group_id: doc.id });
        });
      } else {
        console.log("No Groups found");
        groupArray = false;
      }
      commit("setGroups", groupArray);
      commit("setLoading", false);
      commit("setGroupFirstLoad", false);
      return groupArray;
    },

    // Add Group
    async addGroup({ commit }, payload) {
      const documentReference = doc(collection(db, "Groups"));
      const group = {
        ...payload,
        group_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, group);
      commit("addGroup", group);
    },

    // Get classes by group id
    async getGroupClasses({ commit }, payload) {
      commit("setLoading", true);
      const classes = await getDocs(
        query(
          collection(db, "Classes"),
          where("groups", "array-contains-any", [payload])
        )
      );
      let classesList = [];
      if (!classes.empty) {
        classes.forEach((doc) => {
          classesList.push({ ...doc.data(), class_id: doc.id });
        });
      } else {
        console.log("No Classes found in Group");
        classesList = false;
      }
      commit("setClassesOfGroup", classesList);
      commit("setLoading", false);
      return classesList;
    },

        // get Group By Id
    async getGroupById({ commit }, payload) {
      let group = await getDoc(doc(db, "Groups", payload));
      commit("getSelectedGroupById", group.data());
      return group.data();
    },

        // Update Student
    async updateGroupSelected({ commit }, payload) {
      updateDoc(doc(db, "Groups", payload.group_id), payload);
      commit("updateSelectedGroup", payload);
    },

    async addClassToSelectedGroup({ commit }) {
      commit("setAddClassToGroup");
    },
    // Delete Group
    async deleteGroup({ commit }, payload) {
      deleteDoc(doc(db, "Groups", payload));
      commit("deleteGroup", payload);
    },
  },
};

export default groupsModule;
